import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios, { AxiosRequestConfig } from 'axios';
import { BasicStateTypes } from '../types/types';
import { ADMIN_BASE_URL, HEADERS } from '../utils/config';
import { AppSnackbar } from '../hooks/appSnackbar';

const initialState: BasicStateTypes = {
  loading: false,
  data: null,
  error: null,
};

const buildUrl = (id: number | null, pageNo: string | null, keyword: string | null) => {
  const url = new URL(`${ADMIN_BASE_URL}/photos${id ? `/${id}` : ''}`);
  if (pageNo) {
    url.searchParams.append('page', pageNo);
  }
  if (keyword) {
    url.searchParams.append('name', keyword);
  }
  return url.toString();
};

export const photoCrud = createAsyncThunk(
  'photo/photoCrud',
  async ({ method, data, id }: { method: string, data: any, id: number | null }, { rejectWithValue }) => {
    const searchParams = new URLSearchParams(window.location.search);
    const pageNo = searchParams.get('page');
    const keyword = searchParams.get('keyword');
    
    try {
      const url = buildUrl(id, pageNo, keyword);
      const config: AxiosRequestConfig = {
        method,
        url,
        headers: await HEADERS(),
        data,
      };
      const response = await axios(config);

      if (method === 'POST') {
        AppSnackbar({ type: 'success', message: 'Successfully created' });
      } else if (method === 'PUT' || method === 'PATCH') {
        AppSnackbar({ type: 'success', message: 'Successfully updated' });
      } else if (method === 'DELETE') {
        AppSnackbar({ type: 'success', message: 'Successfully deleted' });
      }
      
      return response.data;
    } catch (error: any) {
      if (error.code === "ERR_BAD_REQUEST") {
        AppSnackbar({ type: 'error', message: 'Network error!' });
      }
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const photoSlice = createSlice({
  name: 'photo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(photoCrud.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(photoCrud.fulfilled, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(photoCrud.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default photoSlice.reducer;
